export class ReqJsonBody {
    [key: string]: any
}